export const HEX_LENGTH = 7

export const TWENTY_PERCENT_ALPHA_HEX = '33'
